import { useFieldContext } from "@carbon6/c6-frontend-design";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import type { EditorController } from "./EditorController";

// Editor가 실제로 필요한 최소 계약이다. 공용 EditorController와, 상태 머신을 이미 소유한
// 도메인 컨트롤러가 모두 이 binding으로 렌더러를 다시 쓸 수 있다.
export type EditorBinding = Pick<EditorController, "inputDisabled" | "setValue" | "value">;

type EditorProps = Omit<
  ComponentPropsWithoutRef<"textarea">,
  "defaultValue" | "disabled" | "onChange" | "value"
> & {
  controller: EditorBinding;
  disabled?: boolean;
};

// 상태와 비동기 동작은 controller가 소유한다. 이 컴포넌트는 textarea 접근성과 입력 가능
// 여부를 일관되게 반영한다. Field 안에서는 디자인 시스템의 label/id/disabled 계약을 따른다.
export const Editor = forwardRef<HTMLTextAreaElement, EditorProps>(function Editor(
  { controller, disabled = false, id, ...props },
  ref,
) {
  const field = useFieldContext();
  return (
    <textarea
      ref={ref}
      {...props}
      id={field?.controlId ?? id}
      aria-labelledby={field?.labelId ?? props["aria-labelledby"]}
      disabled={controller.inputDisabled || disabled || (field?.disabled ?? false)}
      value={controller.value}
      onChange={(event) => controller.setValue(event.target.value)}
    />
  );
});
